import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Button } from 'react-bootstrap';
import axios from 'axios';
import { config } from '../services/api';

function EmailConfirmation() {
  const { key } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        setLoading(true);
        
        // Send confirmation request to backend
        await axios.post(`${config.API_URL}/api/auth/registration/verify-email/`, {
          key: key
        });
        
        setSuccess(true);
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (err) {
        console.error('Email confirmation error:', err);
        setError('La vérification de l\'email a échoué. Le lien est peut-être expiré ou invalide.');
      } finally {
        setLoading(false);
      }
    };

    if (key) {
      confirmEmail();
    }
  }, [key, navigate]);

  return (
    <Container className="py-5 mt-5 text-center">
      <h2 className="mb-4">Confirmation de l'Email</h2>
      
      {loading && (
        <div className="my-5">
          <Spinner animation="border" variant="danger" />
          <p className="mt-3">Vérification de votre email...</p>
        </div>
      )}
      
      {success && (
        <Alert variant="success" className="mb-4">
          <i className="fas fa-check-circle me-2"></i>
          Votre email a été vérifié avec succès! Vous allez être redirigé vers la page de connexion.
        </Alert>
      )}
      
      {error && (
        <>
          <Alert variant="danger" className="mb-4">
            <i className="fas fa-exclamation-circle me-2"></i>
            {error}
          </Alert>
          <Button 
            variant="danger" 
            onClick={() => navigate('/login')}
          >
            Retour à la page de connexion
          </Button>
        </>
      )}
    </Container>
  );
}

export default EmailConfirmation;